import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'
const SessionKey = 'vue_admin_template_session'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setSession(session) {
  return Cookies.set(SessionKey, session)
}

export function getSession(session) {
  return Cookies.get(SessionKey)
}

export function getCookies() {
  return Cookies
}
